//react/redux
import { AiFillCloseCircle } from "react-icons/ai";
import { datadogLogs } from "@datadog/browser-logs";

//components
import Header from "../Common/header";
import { useEffect } from "react";

const Error = ({ tenantImage, tenantName, responseScan, redirect }) => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    const token = urlSearchParams.get("token");

    datadogLogs.logger.info(
        `Process error with the invitationId: ${responseScan?.invitation_id}`,
        {
            invitationId: responseScan?.invitation_id,
            tenantName: tenantName,
        },
    );

    useEffect(() => {
        setTimeout(() => {
            if (redirect) {
                window.location.href = `/setup?token=${token}`;
            }
        }, 7000);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <section className="container mx-auto flex flex-col items-center justify-start gap-5">
                <Header
                    responseScan={responseScan}
                    tenantImage={tenantImage}
                    tenantName={tenantName}
                />
                <div className="px-4 py-24 flex flex-col justify-center items-center gap-4 my-3">
                    <AiFillCloseCircle size={120} className="text-primary-error" />
                    <h2 className="text-2xl">Error!</h2>
                    <p className="text-center text-sm">
                        The authentication process has failed. Please contact support for
                        more information.
                    </p>
                    {redirect ? (
                        <p className="text-center text-sm">
                            The authentication process could not be completed successfully.
                            You will be redirected to the options page for further actions.
                        </p>
                    ) : (
                        <>
                            <p className="text-center text-sm">
                                The authentication process has failed. Please contact support
                                for more information.
                            </p>
                            <p className="text-center text-sm">You may close this tab.</p>
                        </>
                    )}
                </div>
            </section>
        </>
    );
};

export default Error;
